import * as React from 'react'
import { BREAKPOINT_TABLET_LARGE, COLORS } from 'static/constants'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'
import { IconName } from '../../types/icon-names'

// TODO どこかでPropsではなくINavItemとして別で切り出す
export interface INavItemProps {
  label: string
  iconName?: IconName
  href?: string // 後々必須にする
  alart?: number
  active?: boolean
  disabled?: boolean
  dashboard?: boolean
  activate_paths?: any
  children?: any
  defaultOpen?: boolean
}

const getColor = (active: boolean, disabled: boolean) => {
  if (disabled) {
    return COLORS.disabled
  }
  return active ? COLORS.primary : COLORS.black
}

const NavItem: React.VFC<INavItemProps> = ({
  href,
  label,
  iconName,
  alart,
  active,
  disabled,
  dashboard,
  defaultOpen,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(
    !!children?.find(child => child.active) || defaultOpen
  )

  const showAlart = alart
  const hasChildlen = children?.length > 0
  return (
    <>
      <Item
        active={children ? false : active}
        disabled={disabled}
        iconName={iconName}
        dashboard={dashboard}
      >
        <a
          className={`NavItem_Link ${hasChildlen ? 'hasChildlen' : ''}`}
          href={hasChildlen ? undefined : href}
          onClick={e => hasChildlen && setIsOpen(!isOpen)}
        >
          {iconName && (
            <SvgIcon name={iconName} className="icon" ariaHidden={true} role="presentation" />
          )}
          <span className="NavItem_Label">{label}</span>
          {showAlart && <Alart>{alart}</Alart>}
          {hasChildlen && (
            <div className="toggle">
              <SvgIcon
                name={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                className="icon"
              />
            </div>
          )}
        </a>
      </Item>
      {hasChildlen &&
        children.map(child => (
          <Item
            active={child.active}
            disabled={child.disabled}
            dashboard={dashboard}
            hasChildlen={hasChildlen}
            isOpen={isOpen}
            key={child.label}
          >
            <a className="NavItem_Link" href={child.href} key={child.label}>
              <span className="NavItem_Label">{child.label}</span>
            </a>
          </Item>
        ))}
    </>
  )
}

const Item = styled.div`
  position: relative;
  box-sizing: border-box;
  display: ${props => (props.hasChildlen && !props.isOpen ? 'none' : 'flex')};
  align-items: center;
  color: ${props => getColor(props.active, props.disabled)};
  padding-left: ${props => (props.iconName ? 24 : props.hasChildlen ? 49 : 0)}px;
  font-size: ${props => (props.hasChildlen ? '13px' : 'inherit')};
  border-left: 4px solid ${props => (props.active ? COLORS.primary : 'transparent')};
  border-bottom: none;

  .NavItem_Link {
    display: flex;
    align-items: center;
    width: 100%;
    text-decoration: none;
    color: inherit;

    &.hasChildlen {
      cursor: pointer;
    }
  }
  .NavItem_Label {
    margin-left: 16px;
  }
  ${props =>
    props.active &&
    `
      font-weight: 700;
    `};

  @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
    flex-shrink: 0;
    height: auto;
    font-size: 14px;
    padding-top: 4px;
    padding-left: 0;
    border-left: ${props => !props.dashboard && 'none'};
    border-bottom: ${props =>
      !props.dashboard && `4px solid ${props.active ? COLORS.primary : 'transparent'}`};

    .icon {
      width: 22px;
      height: 22px;
    }
    .NavItem_Label {
      margin: 0 11px;
      padding: 4px 0;
    }
  }
`
const Alart = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  color: ${COLORS.white};
  background-color: ${COLORS.caution};
`

export default NavItem
